import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// Marked pure so the production build drops these page chunks along with the routes below.
const DebugSplashPage = /* @__PURE__ */ lazy(() => import('src/pages/debug/splash'));
const DebugLoadingPage = /* @__PURE__ */ lazy(() => import('src/pages/debug/loading'));

// ----------------------------------------------------------------------

// These pages hold a loading state on screen indefinitely, so they are not routable in production.
export const debugRoutes = import.meta.env.DEV
  ? [
      {
        path: 'debug',
        element: (
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        ),
        children: [
          { path: 'splash', element: <DebugSplashPage /> },
          { path: 'loading', element: <DebugLoadingPage /> },
        ],
      },
    ]
  : [];
